import { render, staticRenderFns } from "./PageHistory.vue?vue&type=template&id=1d8b6af2&"
import script from "./PageHistory.vue?vue&type=script&lang=js&"
export * from "./PageHistory.vue?vue&type=script&lang=js&"
import style0 from "./PageHistory.vue?vue&type=style&index=0&id=1d8b6af2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports